import React from 'react';
import { motion } from 'framer-motion';
import { Gift, CheckCircle2 } from 'lucide-react';
const MOCKUP_IMAGE = 'https://cdn.magicpatterns.com/uploads/jdVrssbjQjGtppE5kJgSN1/ChatGPT_Image_4_abr_2026,_11_07_59_p.m..png';
const bonuses = [{
  title: 'Recetas premium para cobrar más caro',
  description: 'Variantes gourmet para diferenciarte y aumentar tu margen de ganancia.',
  value: '$15.000'
}, {
  title: 'Plantillas de Instagram listas para vender',
  description: 'Diseños profesionales para tus historias y posts. Solo cambiás el texto y publicás.',
  value: '$25.000'
}, {
  title: 'Guiones de WhatsApp para cerrar ventas',
  description: 'Qué responder exactamente para que la gente te compre sin dudarlo.',
  value: '$20.000'
}, {
  title: 'Guía de fotos y presentación',
  description: 'Cómo sacar fotos que den hambre con tu celular y empacar barato pero premium.',
  value: '$18.000'
}];
export function BonusSection() {
  return <section className="py-24 px-4 sm:px-6 lg:px-8 bg-warmBrown relative overflow-hidden" data-id="element-16">
      <div className="absolute inset-0 opacity-10 bg-[radial-gradient(circle_at_top_right,rgba(212,168,83,1)_0%,transparent_40%)]" data-id="element-17" />
      <div className="absolute inset-0 opacity-10 bg-[radial-gradient(circle_at_bottom_left,rgba(212,168,83,1)_0%,transparent_40%)]" data-id="element-18" />

      <div className="max-w-6xl mx-auto relative z-10" data-id="element-19">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.6
      }} className="text-center mb-16" data-id="element-20">
          <div className="inline-flex items-center justify-center w-16 h-16 rounded-full bg-gold/20 text-gold mb-6 border border-gold/30" data-id="element-21">
            <Gift className="w-8 h-8" data-id="element-22" />
          </div>
          <h2 className="text-4xl md:text-5xl font-bold mb-6 tracking-wide" data-id="element-23">
            🔥 Si empezás hoy, te llevás{' '}
            <span className="text-gold italic font-normal" data-id="element-24">
              TODO esto GRATIS
            </span>
          </h2>
          <p className="text-2xl text-gold-light font-serif" data-id="element-25">
            Valor real: +$70.000
          </p>
        </motion.div>

        <div className="grid lg:grid-cols-2 gap-10 lg:gap-14 items-stretch" data-id="element-26">
          <motion.div initial={{
          opacity: 0,
          x: -30
        }} whileInView={{
          opacity: 1,
          x: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.7
        }} className="relative flex items-center justify-center" data-id="element-27">
            <div className="absolute inset-0 bg-gold/10 blur-[50px] rounded-full pointer-events-none" data-id="element-28" />
            <img src={MOCKUP_IMAGE} alt="Pack completo: Ebook en tablet con los 4 bonus" className="relative z-10 w-full h-full object-contain max-h-[600px] drop-shadow-[0_20px_40px_rgba(0,0,0,0.4)] rounded-2xl" data-id="element-29" />
          </motion.div>

          <div className="flex flex-col gap-5 justify-center" data-id="element-30">
            {bonuses.map((bonus, index) => <motion.div key={index} initial={{
            opacity: 0,
            x: 20
          }} whileInView={{
            opacity: 1,
            x: 0
          }} viewport={{
            once: true
          }} transition={{
            duration: 0.5,
            delay: index * 0.1
          }} className="bg-charcoal/80 backdrop-blur-sm border border-gold/20 rounded-2xl p-6 relative overflow-hidden group hover:bg-charcoal transition-colors" data-id="element-31">
                <div className="absolute top-0 right-0 bg-gold/10 text-gold text-xs font-bold px-3 py-1.5 rounded-bl-lg border-b border-l border-gold/20" data-id="element-32">
                  Valor: {bonus.value}
                </div>

                <div className="flex gap-4" data-id="element-33">
                  <div className="flex-shrink-0 mt-0.5" data-id="element-34">
                    <CheckCircle2 className="w-6 h-6 text-gold" data-id="element-35" />
                  </div>
                  <div data-id="element-36">
                    <h3 className="text-lg font-serif font-semibold mb-1.5 text-cream group-hover:text-gold-light transition-colors pr-20" data-id="element-37">
                      {bonus.title}
                    </h3>
                    <p className="text-cream-muted/80 text-sm leading-relaxed" data-id="element-38">
                      {bonus.description}
                    </p>
                  </div>
                </div>
              </motion.div>)}
          </div>
        </div>

        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.6,
        delay: 0.4
      }} className="mt-16 text-center" data-id="element-39">
          <p className="text-xl sm:text-2xl font-serif text-gold font-medium" data-id="element-40">
            Valor total de los bonus: $78.000 ARS <br className="sm:hidden" data-id="element-41" />
            <span className="text-cream-muted text-lg sm:text-xl font-sans font-normal" data-id="element-42">
              · Incluidos gratis con tu compra hoy
            </span>
          </p>
        </motion.div>
      </div>
    </section>;
}